import React from "react";
import { TemplatePanel } from "./TemplatePanel";
import { DefaultRouteParam, StorageProviderRouteParam } from "constants/routes";
import { useParams } from "react-router-dom";

export interface ITemplatePanelContainerProps {
  onClose: () => void;
}

export const TemplatePanelContainer = ({
  onClose,
}: ITemplatePanelContainerProps) => {
  const { idOrAction } = useParams<{
    [DefaultRouteParam.IdOrAction]: string;
  }>();
  return (
    <TemplatePanel
      isOpen={idOrAction == StorageProviderRouteParam.Template}
      onClose={onClose}
    />
  );
};
